import { Component } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { api_constants } from '../../constants/api-constants';
import { S3UploadType } from '../../constants/enum';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-icon-upload',
  templateUrl: './icon-upload.component.html',
  styleUrls: ['./icon-upload.component.scss']
})
export class IconUploadComponent {

  image_list: any;
  file: any = [];
  file_list: any = [];
  selected_images: any[] = [];
  image_loader: boolean = false;
  button_loader: boolean = false;

  constructor(
    private api: ApiService,
    private _dialog: MatDialog,
    private _toast: ToastrService,
    public _dialogRef: MatDialogRef<IconUploadComponent>,
  ) { }



  onFileChange(event: any) {
    if (event?.target?.files && event?.target?.files[0]) {
      this.file = event?.target?.files[0];
      this.getPresignedUrl(this.file);
      this.image_loader = true;
    }
  }

  getPresignedUrl(file: any) {
    let body = {
      type: S3UploadType.IMAGES,
      file_name: file?.name,
    };
    let $this = this;
    this.api
      .ExecutePost(this.api?.baseUrl + api_constants?.preurlrequest, body)
      .subscribe((responce: any) => {
        if (responce) {
          $this.uploadImageFile(responce, this.file, this.file?.name);
        }
      });
  }

  uploadImageFile(result: any, file: any, fileName: string) {
    this.api.ExecutePut(result?.upload_url[0], file).subscribe((response) => {
      this.selected_images.push({
        url: result?.url,
        key: result?.key,
      });
      this.image_loader = false;
    });
  }

  deletProduct(e: any) {
    let index = this.selected_images.findIndex(
      (item: { key: any }) => item?.key == e?.key
    );
    if (index !== -1) {
      this.selected_images.splice(index, 1);
    }
  }

  submit() {

    this.button_loader = true;

    if (this.selected_images.length == 0) {
      this._toast.warning('Please select an icon', 'Warning', {
        closeButton: true,
      });
    } else {
      let payload = {
        url: this.selected_images[0]?.url,
        key: this.selected_images[0]?.key
      }
      let $this = this;
      this.api
        .ExecutePost(this.api?.baseUrl + api_constants?.create_icon, payload)
        .subscribe({
          next(value: any) {
            $this._toast.success('Icon added succesfully', 'Successfuly Added',
              {
                closeButton: true,
              }
            );
            $this._dialogRef.close(true);
            $this.button_loader = false;
          },
          error(err) {
            console.log('Error', err);
            $this.button_loader = false;
          },
        });
    }
  }

   close() {
    this._dialogRef.close();
  }



}
